<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal" id="menu-popup">
      <form>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              v-model="model.name"
              name="menuName"
              :label="$t('Name')"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('menuName')">{{
              errors.first("menuName")
            }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full" v-if="model">
            <label class="vs-select--label"
              >{{ $t("ParentCategory") }}<span v-if="model.parentName">:</span
              >{{ model.parentName }}</label
            >
            <treeselect
              :multiple="false"
              :placeholder="$t('Search')"
              :async="true"
              :load-options="loadOptions"
              :clearable="clearable"
              class="mb-4 mt-1"
              @select="onParentSelected"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              v-model="model.displayOrder"
              name="Order"
              :label="$t('DisplayOrder')"
              v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
            />
            <span class="text-danger text-sm" v-show="errors.has('Order')">{{
              errors.first("Order")
            }}</span>
          </div>
        </div>

        <div class="vx-row" v-if="!model.parent">
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
            <div class="upload-menu-wrapper">
              <my-upload
                field="img"
                @crop-success="cropSuccess"
                v-model="showUpload"
                :width="200"
                :height="200"
                langType="fa"
                img-format="jpg"
              ></my-upload>
              <img :src="model.image" v-if="model.image" />
              <img
                :src="URLS_CONSTANTS.assets + 'Menu/' + model.imageUri"
                v-if="model.imageUri"
              />
              <button
                v-if="model.imageUri || model.image"
                @click.prevent="removeImg"
                class="removeImg"
              >
                <feather-icon icon="XIcon" />
              </button>
            </div>
            <a class="menu-img-box" @click.prevent="toggleShow">
              {{ $t("UploadImage")
              }}<i class="material-icons notranslate"> cloud_upload </i>
            </a>
          </div>
        </div>

        <div class="vx-row mt-4">
          <div class="vx-col">
            <vs-checkbox v-model="model.published">{{
              $t("Published")
            }}</vs-checkbox>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col">
            <vs-checkbox v-model="model.showOnHomePage">{{
              $t("ShowOnHomePage")
            }}</vs-checkbox>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col">
            <vs-checkbox v-model="model.includeInTopMenu">{{
              $t("IncludeInTopMenu")
            }}</vs-checkbox>
          </div>
        </div>
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.removeIco {
  float: left !important;
  top: 10px !important;
  left: 10px !important;
}
</style>

<script>
import { URLS_CONSTANTS } from "../../../../config";
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import myUpload from "vue-image-crop-upload";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

const dict = {
  custom: {
    menuName: {
      required: "لطفا نام منو را وارد نمایید.",
    },
    Order: {
      required: "لطفا الویت نمایش را انتخاب نمایید.",
      regex: "مقدار ورودی درست نمی‌باشد.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "Content_management_Menus_ModifyPopup",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
  },
  data() {
    return {
      popupTitle: "",
      clearable: true,
      showUpload: false,
      searchQueryNew: "",
      searchQueryOld: "",
      URLS_CONSTANTS: URLS_CONSTANTS,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createMenu: "menu/create",
      updateMenu: "menu/update",
      fetchSearch: "menu/fetchMenusSearch",
    }),
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchSearch(searchQuery).then((r) => {
              const options = [];
              r.data.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.name,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onParentSelected(data) {
      this.model.parent = data.id;
      this.model.parentName = data.label;
    },
    cropSuccess(imgDataUrl) {
      this.model.image = imgDataUrl;
      this.$swal({
        position: "center-center",
        type: "success",
        text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
        showConfirmButton: false,
        timer: 2000,
      });
    },
    toggleShow() {
      this.showUpload = !this.showUpload;
    },
    removeImg() {
      this.model.imageUri = "";
      this.model.image = "";
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.model.id != null) {
            this.updateMenu(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
            });
          } else {
            this.createMenu(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
            });
          }
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        if (this.model.id) this.popupTitle = "EditMenu";
        else this.popupTitle = "CreateNewMenu";
      }
      this.$validator.reset();
    },
  },
  components: {
    Treeselect,
    "my-upload": myUpload,
  },
};
</script>
